/** Вход, регистрация, сброс пароля, onboarding. */
export const AUTH_RU = {
  'welcome.cta': 'Начать',
  'auth.tabLogin': 'Вход в аккаунт',
  'auth.tabRegister': 'Регистрация',
  'auth.loginSubtitle': 'Введите email и пароль для входа в аккаунт',
  'auth.password': 'Пароль',
  'auth.showPassword': 'Показать пароль',
  'auth.hidePassword': 'Скрыть пароль',
  'auth.forgotPassword': 'Забыли пароль?',
  'auth.loginSubmit': 'Войти',
  'auth.loginLoading': 'Вход...',
  'auth.or': 'или',
  'auth.googleOpenFail': 'Не удалось открыть вход Google',
  'auth.registerSubtitle': 'Создайте аккаунт для начала работы',
  'auth.pickAvatar': 'Выбрать аватар',
  'auth.name': 'Имя',
  'auth.namePlaceholder': 'Введите ваше имя',
  'auth.email': 'Email',
  'auth.emailPlaceholder': 'Введите email',
  'auth.passwordMinPlaceholder': 'Минимум 8 символов',
  'auth.confirmPassword': 'Повторите пароль',
  'auth.acceptTerms': 'Принимаю условия использования',
  'auth.registerSubmit': 'Зарегистрироваться',
  'auth.registerLoading': 'Регистрация...',
  'auth.loginSuccess': '🎉 Успешный вход! Рады вас видеть.',
  'auth.userNotFound':
    '🚫 Пользователь с таким email не найден. Проверьте данные или зарегистрируйтесь.',
  'auth.wrongPassword':
    '❌ Неверный пароль. Попробуйте ещё раз или воспользуйтесь функцией «Забыли пароль?»',
  'auth.loginFailed': 'Ошибка входа',
  'auth.serverError': '⚠️ Произошла ошибка на сервере. Попробуйте ещё раз.',
  'auth.registerPrepFail': 'Не удалось подготовить регистрацию. Попробуйте снова.',
  'auth.registerSuccess': '🎉 Регистрация успешна! Добро пожаловать!',
  'auth.nicknameTaken':
    'Регистрация не удалась из‑за занятого никнейма. Нажмите «Зарегистрироваться» ещё раз.',
  'auth.registerFailed': 'Ошибка регистрации',
  'auth.googleNoData': 'Google не вернул данные для входа',
  'auth.googleSuccess': '🎉 Вход через Google выполнен!',
  'auth.googleError': 'Ошибка входа через Google',
  'auth.googleContinue': 'Войти через Google',
  'auth.googleSignup': 'Регистрация через Google',
  'auth.appleContinue': 'Войти через Apple',
  'auth.appleNoData': 'Apple не вернул данные для входа',
  'auth.appleSuccess': '🎉 Вход через Apple выполнен!',
  'auth.appleError': 'Ошибка входа через Apple',
  'auth.appleNotReady': 'Кнопка Apple ещё загружается. Обновите страницу.',
  'auth.networkError': '⚠️ Ошибка сети. Попробуйте ещё раз.',
  'auth.enterEmail': 'Введите email',
  'auth.enterNickname': 'Пожалуйста, введите ваш nickname',
  'auth.resetSendFail': 'Не удалось отправить запрос',
  'auth.resetCheckEmail': 'Проверьте почту',
  'auth.resetNetwork': 'Ошибка сети',
  'auth.resetTimeout': 'Сервер долго не отвечает. Попробуйте позже или проверьте почту — ссылка могла уже уйти.',
  'auth.validation.emailRequired': 'Email обязателен',
  'auth.validation.emailInvalid': 'Пожалуйста, введите корректный email',
  'auth.validation.passwordRequired': 'Пароль обязателен',
  'auth.validation.nameMin': 'Имя должно содержать минимум 2 символа',
  'auth.validation.passwordMin': 'Пароль должен содержать минимум 8 символов',
  'auth.validation.confirmRequired': 'Подтвердите пароль',
  'auth.validation.acceptTerms': 'Необходимо принять условия',
  'auth.validation.passwordsMismatch': 'Пароли не совпадают',

  'reset.invalidLink':
    'Ссылка неполная или устарела. Запросите сброс пароля на экране входа.',
  'reset.toLogin': 'На страницу входа',
  'reset.passwordShort': 'Пароль не менее 8 символов',
  'reset.passwordsMismatch': 'Пароли не совпадают',
  'reset.fail': 'Не удалось сменить пароль',
  'reset.success': 'Пароль обновлён. Войдите с новым паролем.',
  'reset.subtitle': 'Новый пароль для вашего аккаунта',
  'reset.newPassword': 'Новый пароль',
  'reset.confirm': 'Подтвердите пароль',
  'reset.submit': 'Сохранить пароль',
  'reset.network': 'Ошибка сети',

  'tg.nameTitle': 'Как вас называть?',
  'tg.nameHint': 'Это имя увидят клиенты в расписании и профиле',
  'tg.pickAvatar': 'Выбрать аватар',
  'tg.photoLabel': 'Фото профиля',
  'tg.nameLabel': 'Имя',
  'tg.namePlaceholder': 'Например, Мария Иванова',
  'tg.creating': 'Создаём профиль…',
  'tg.create': 'Создать профиль',
  'tg.nameTooShort': 'Введите имя — не меньше 3 букв',
  'tg.done': 'Готово',
  'tg.saveFail': 'Не удалось сохранить',
  'tg.avatarPickerTitle': 'Выберите аватар',

  'auth.agreePrefix': 'Я согласен с',
  'auth.termsLink': 'Пользовательским соглашением',
  'auth.andWith': 'и',
  'auth.privacyLink': 'Политикой конфиденциальности',
  'auth.existsTitle': 'Вы уже зарегистрированы!',
  'auth.existsBody':
    'Пользователь с email {email} уже есть. Войти в аккаунт или сбросить пароль?',
  'auth.resetPasswordBtn': 'Сбросить пароль',
  'auth.forgotDialogTitle': 'Восстановление пароля',
  'auth.forgotSendLink': 'Отправить ссылку',
  'auth.forgotSending': 'Отправка…',
};

export const AUTH_EN = {
  'welcome.cta': 'Get started',
  'auth.tabLogin': 'Sign in',
  'auth.tabRegister': 'Sign up',
  'auth.loginSubtitle': 'Enter your email and password to continue',
  'auth.password': 'Password',
  'auth.showPassword': 'Show password',
  'auth.hidePassword': 'Hide password',
  'auth.forgotPassword': 'Forgot password?',
  'auth.loginSubmit': 'Sign in',
  'auth.loginLoading': 'Signing in…',
  'auth.or': 'or',
  'auth.googleOpenFail': 'Couldn’t open Google sign-in',
  'auth.registerSubtitle': 'Create an account to get started',
  'auth.pickAvatar': 'Choose avatar',
  'auth.name': 'Name',
  'auth.namePlaceholder': 'Your name',
  'auth.email': 'Email',
  'auth.emailPlaceholder': 'Enter email',
  'auth.passwordMinPlaceholder': 'At least 8 characters',
  'auth.confirmPassword': 'Confirm password',
  'auth.acceptTerms': 'I accept the terms of use',
  'auth.registerSubmit': 'Create account',
  'auth.registerLoading': 'Creating account…',
  'auth.loginSuccess': '🎉 Signed in successfully!',
  'auth.userNotFound':
    '🚫 No account with this email. Check your details or sign up.',
  'auth.wrongPassword': '❌ Wrong password. Try again or use “Forgot password”.',
  'auth.loginFailed': 'Sign-in failed',
  'auth.serverError': '⚠️ Something went wrong on the server. Try again.',
  'auth.registerPrepFail': 'Couldn’t start registration. Try again.',
  'auth.registerSuccess': '🎉 Account created! Welcome!',
  'auth.nicknameTaken': 'Nickname taken. Tap “Create account” again.',
  'auth.registerFailed': 'Registration failed',
  'auth.googleNoData': 'Google didn’t return sign-in data',
  'auth.googleSuccess': '🎉 Signed in with Google!',
  'auth.googleError': 'Google sign-in failed',
  'auth.googleContinue': 'Continue with Google',
  'auth.googleSignup': 'Sign up with Google',
  'auth.appleContinue': 'Sign in with Apple',
  'auth.appleNoData': 'Apple didn’t return sign-in data',
  'auth.appleSuccess': '🎉 Signed in with Apple!',
  'auth.appleError': 'Apple sign-in failed',
  'auth.appleNotReady': 'Apple sign-in is still loading. Refresh the page.',
  'auth.networkError': '⚠️ Network error. Try again.',
  'auth.enterEmail': 'Enter your email',
  'auth.enterNickname': 'Please enter your nickname',
  'auth.resetSendFail': 'Couldn’t send request',
  'auth.resetCheckEmail': 'Check your inbox',
  'auth.resetNetwork': 'Network error',
  'auth.resetTimeout': 'The server took too long. Try again later, or check your inbox—the message may have sent.',
  'auth.validation.emailRequired': 'Email is required',
  'auth.validation.emailInvalid': 'Enter a valid email',
  'auth.validation.passwordRequired': 'Password is required',
  'auth.validation.nameMin': 'Name must be at least 2 characters',
  'auth.validation.passwordMin': 'Password must be at least 8 characters',
  'auth.validation.confirmRequired': 'Confirm your password',
  'auth.validation.acceptTerms': 'Please accept the terms',
  'auth.validation.passwordsMismatch': 'Passwords don’t match',

  'reset.invalidLink':
    'This link is incomplete or expired. Request a new reset from the sign-in screen.',
  'reset.toLogin': 'Back to sign in',
  'reset.passwordShort': 'Password must be at least 8 characters',
  'reset.passwordsMismatch': 'Passwords don’t match',
  'reset.fail': 'Couldn’t reset password',
  'reset.success': 'Password updated. Sign in with your new password.',
  'reset.subtitle': 'Set a new password for your account',
  'reset.newPassword': 'New password',
  'reset.confirm': 'Confirm password',
  'reset.submit': 'Save password',
  'reset.network': 'Network error',

  'tg.nameTitle': 'What should we call you?',
  'tg.nameHint': 'Clients will see this name in the schedule and profile',
  'tg.pickAvatar': 'Choose avatar',
  'tg.photoLabel': 'Profile photo',
  'tg.nameLabel': 'Name',
  'tg.namePlaceholder': 'e.g. Alex Morgan',
  'tg.creating': 'Creating profile…',
  'tg.create': 'Create profile',
  'tg.nameTooShort': 'Enter at least 3 letters',
  'tg.done': 'Done',
  'tg.saveFail': 'Couldn’t save',
  'tg.avatarPickerTitle': 'Choose an avatar',

  'auth.agreePrefix': 'I agree to the',
  'auth.termsLink': 'Terms of Service',
  'auth.andWith': 'and',
  'auth.privacyLink': 'Privacy Policy',
  'auth.existsTitle': 'You already have an account',
  'auth.existsBody': 'An account with {email} already exists. Sign in or reset your password?',
  'auth.resetPasswordBtn': 'Reset password',
  'auth.forgotDialogTitle': 'Reset password',
  'auth.forgotSendLink': 'Send reset link',
  'auth.forgotSending': 'Sending…',
};

export const AUTH_ES = {
  'welcome.cta': 'Empezar',
  'auth.tabLogin': 'Iniciar sesión',
  'auth.tabRegister': 'Registrarse',
  'auth.loginSubtitle': 'Introduce correo y contraseña para continuar',
  'auth.password': 'Contraseña',
  'auth.showPassword': 'Mostrar contraseña',
  'auth.hidePassword': 'Ocultar contraseña',
  'auth.forgotPassword': '¿Olvidaste la contraseña?',
  'auth.loginSubmit': 'Entrar',
  'auth.loginLoading': 'Entrando…',
  'auth.or': 'o',
  'auth.googleOpenFail': 'No se pudo abrir el inicio de sesión con Google',
  'auth.registerSubtitle': 'Crea una cuenta para comenzar',
  'auth.pickAvatar': 'Elegir avatar',
  'auth.name': 'Nombre',
  'auth.namePlaceholder': 'Tu nombre',
  'auth.email': 'Correo',
  'auth.emailPlaceholder': 'Correo electrónico',
  'auth.passwordMinPlaceholder': 'Al menos 8 caracteres',
  'auth.confirmPassword': 'Repite la contraseña',
  'auth.acceptTerms': 'Acepto los términos de uso',
  'auth.registerSubmit': 'Crear cuenta',
  'auth.registerLoading': 'Creando cuenta…',
  'auth.loginSuccess': '🎉 ¡Sesión iniciada!',
  'auth.userNotFound': '🚫 No hay cuenta con este correo. Revísalo o regístrate.',
  'auth.wrongPassword':
    '❌ Contraseña incorrecta. Inténtalo de nuevo o usa «Olvidé mi contraseña».',
  'auth.loginFailed': 'No se pudo iniciar sesión',
  'auth.serverError': '⚠️ Error en el servidor. Inténtalo de nuevo.',
  'auth.registerPrepFail': 'No pudimos iniciar el registro. Inténtalo de nuevo.',
  'auth.registerSuccess': '🎉 ¡Cuenta creada! Bienvenido/a.',
  'auth.nicknameTaken': 'Ese alias ya está en uso. Pulsa «Crear cuenta» otra vez.',
  'auth.registerFailed': 'Error al registrarse',
  'auth.googleNoData': 'Google no devolvió datos de sesión',
  'auth.googleSuccess': '🎉 ¡Sesión con Google correcta!',
  'auth.googleError': 'Error al iniciar sesión con Google',
  'auth.googleContinue': 'Continuar con Google',
  'auth.googleSignup': 'Registrarse con Google',
  'auth.appleContinue': 'Iniciar sesión con Apple',
  'auth.appleNoData': 'Apple no devolvió datos de sesión',
  'auth.appleSuccess': '🎉 ¡Sesión con Apple correcta!',
  'auth.appleError': 'Error al iniciar sesión con Apple',
  'auth.appleNotReady': 'El inicio con Apple aún se carga. Actualiza la página.',
  'auth.networkError': '⚠️ Error de red. Inténtalo de nuevo.',
  'auth.enterEmail': 'Introduce tu correo',
  'auth.enterNickname': 'Por favor introduce tu alias',
  'auth.resetSendFail': 'No se pudo enviar la solicitud',
  'auth.resetCheckEmail': 'Revisa tu correo',
  'auth.resetNetwork': 'Error de red',
  'auth.resetTimeout': 'El servidor tardó demasiado. Inténtalo de nuevo o revisa el correo; el mensaje puede haberse enviado.',
  'auth.validation.emailRequired': 'El correo es obligatorio',
  'auth.validation.emailInvalid': 'Introduce un correo válido',
  'auth.validation.passwordRequired': 'La contraseña es obligatoria',
  'auth.validation.nameMin': 'El nombre debe tener al menos 2 caracteres',
  'auth.validation.passwordMin': 'La contraseña debe tener al menos 8 caracteres',
  'auth.validation.confirmRequired': 'Confirma la contraseña',
  'auth.validation.acceptTerms': 'Debes aceptar los términos',
  'auth.validation.passwordsMismatch': 'Las contraseñas no coinciden',

  'reset.invalidLink':
    'El enlace está incompleto o caducó. Solicita uno nuevo en la pantalla de acceso.',
  'reset.toLogin': 'Volver al acceso',
  'reset.passwordShort': 'La contraseña debe tener al menos 8 caracteres',
  'reset.passwordsMismatch': 'Las contraseñas no coinciden',
  'reset.fail': 'No se pudo restablecer la contraseña',
  'reset.success': 'Contraseña actualizada. Entra con la nueva.',
  'reset.subtitle': 'Nueva contraseña para tu cuenta',
  'reset.newPassword': 'Nueva contraseña',
  'reset.confirm': 'Confirmar contraseña',
  'reset.submit': 'Guardar contraseña',
  'reset.network': 'Error de red',

  'tg.nameTitle': '¿Cómo te llamamos?',
  'tg.nameHint': 'Los clientes verán este nombre en la agenda y el perfil',
  'tg.pickAvatar': 'Elegir avatar',
  'tg.photoLabel': 'Foto de perfil',
  'tg.nameLabel': 'Nombre',
  'tg.namePlaceholder': 'p. ej. María García',
  'tg.creating': 'Creando perfil…',
  'tg.create': 'Crear perfil',
  'tg.nameTooShort': 'Escribe al menos 3 letras',
  'tg.done': 'Listo',
  'tg.saveFail': 'No se pudo guardar',
  'tg.avatarPickerTitle': 'Elige un avatar',

  'auth.agreePrefix': 'Acepto la',
  'auth.termsLink': 'Condiciones del servicio',
  'auth.andWith': 'y la',
  'auth.privacyLink': 'Política de privacidad',
  'auth.existsTitle': '¡Ya tienes cuenta!',
  'auth.existsBody':
    'Ya existe una cuenta con {email}. ¿Entrar o restablecer contraseña?',
  'auth.resetPasswordBtn': 'Restablecer contraseña',
  'auth.forgotDialogTitle': 'Recuperar contraseña',
  'auth.forgotSendLink': 'Enviar enlace',
  'auth.forgotSending': 'Enviando…',
};
